"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateExpressionList = exports.evaluateFractionExpression = exports.evaluateExpression = exports.replaceVariablesWithValues = void 0;
const tokeniser_1 = require("./tokeniser");
const token_utils_1 = require("./token-utils");
const types_1 = require("./types");
const matchers_1 = require("./matchers");
const value_wrappers_1 = require("../value-wrappers");
const generator_functions_1 = require("./generator-functions");
const removeWhiteSpace = (str) => str.replace(/\s+/g, '');
// Regular expressions used to match token value-types at the start of the text.
const simpleMatchers = [
    matchers_1.SpeechSingleMatcher,
    matchers_1.SpeechDoubleMatcher,
    matchers_1.ComparisonMatcher,
    matchers_1.InvalidOpComboMatcher,
    matchers_1.InvalidOpTripletMatcher,
    matchers_1.InvalidDecimalMatcher,
    matchers_1.WhitespaceMatcher,
    matchers_1.IntegerMatcher,
    matchers_1.OperatorMatcher,
    matchers_1.FunctionMatcher,
    matchers_1.PlaceholderMatcher,
    matchers_1.VariableMatcher,
    matchers_1.CommaMatcher,
    matchers_1.SpreadMatcher,
    matchers_1.ParensMatcher,
    matchers_1.SquareParensMatcher,
];
// Initial string preparation
function replaceDoubleOperators(text) {
    return text
        .replace(/--|\+\+/g, '+')
        .replace(/-\+|\+-/g, '-');
}
// Returns true if there's a variable name that doesn't appear
// in the provided list of state keys.
function hasMissingVariable(variableNames, stateKeys) {
    return variableNames.some((v) => !stateKeys.includes(v));
}
// This seems to need to be here for eval to see these functions.
const generatorFns = generator_functions_1.generatorFunctions;
// Exported functions
function replaceVariablesWithValues(text, state = {}, matchers = simpleMatchers) {
    // const preparedText = replaceDoubleOperators(removeWhiteSpace(text));
    const preparedText = replaceDoubleOperators(text);
    let tokens = (0, tokeniser_1.getTokens)(preparedText, matchers);
    if ((0, tokeniser_1.hasUnknownToken)(tokens))
        return (0, value_wrappers_1.makeError)(`Parse error: "${text}" contains unsupported characters`);
    const placeholders = (0, token_utils_1.getStrippedVariableNames)(tokens);
    if (hasMissingVariable(placeholders, (0, token_utils_1.getStateKeys)(state))) {
        return {
            kind: 'error',
            value: `Unknown placeholder in expression: ${text}`,
        };
    }
    const textWithoutPlaceholders = tokens
        .map((t) => t.type === types_1.TokenType.PLACEHOLDER
        ? (0, token_utils_1.getVariableFromState)((0, token_utils_1.stripSymbols)(t.value), state)
        : t.value).join('');
    tokens = (0, tokeniser_1.getTokens)(textWithoutPlaceholders, matchers);
    const variables = (0, token_utils_1.getVariableNames)(tokens);
    if ((0, token_utils_1.hasMissingVariableName)(variables, (0, token_utils_1.getStateKeys)(state)))
        return (0, value_wrappers_1.makeError)(`Unknown variable in expression: ${text}`);
    const textWithoutVariables = variables.reduce((expression, v) => {
        let value = (0, token_utils_1.getVariableFromState)(v, state);
        if (Array.isArray(value))
            value = `[${value.map((i) => JSON.stringify(i)).join(',')}]`;
        if (typeof value === "object")
            value = JSON.stringify(value);
        return expression.replace(v, value);
    }, textWithoutPlaceholders);
    tokens = (0, tokeniser_1.getTokens)(textWithoutVariables, matchers);
    const textWithFunctions = tokens.map((t) => {
        if (t.type !== types_1.TokenType.FUNCTION)
            return t.value;
        return generator_functions_1.functionMap[t.value];
    }).join('');
    return (0, value_wrappers_1.makeValue)(textWithFunctions, variables);
}
exports.replaceVariablesWithValues = replaceVariablesWithValues;
// Uses JavaScript eval to convert an expression into a value.
function evaluateExpression(text, state = {}, matchers = simpleMatchers) {
    if (text.trim() === '')
        return (0, value_wrappers_1.makeError)('At least one rule for this value is missing an expression.');
    const result = replaceVariablesWithValues(text, state, matchers);
    if (result.kind === 'error')
        return result;
    let value;
    // eslint-disable-next-line
    try {
        value = eval(result.value);
    }
    catch (e) {
        // return makeError(`The expression '${result.value}' cannot be evaluated.`);
        try {
            value = JSON.parse(result.value);
        }
        catch (e) {
            value = result.value;
        }
    }
    return (0, value_wrappers_1.makeValue)(value, result.variables);
}
exports.evaluateExpression = evaluateExpression;
function evaluateFractionExpression(text, state = {}, matchers = simpleMatchers) {
    if (text.trim() === '')
        return (0, value_wrappers_1.makeError)('At least one rule for this value is missing an expression.');
    const result = replaceVariablesWithValues(text, state, matchers);
    if (result.kind === 'error')
        return result;
    // eslint-disable-next-line
    const value = eval(result.value);
    return (0, value_wrappers_1.makeValue)(value);
}
exports.evaluateFractionExpression = evaluateFractionExpression;
function evaluateExpressionList(items, state) {
    var _a, _b;
    const result = (items || []).map((item) => evaluateExpression(item, state));
    return result.some((item) => item.kind === 'error')
        ? (0, value_wrappers_1.makeError)((_b = (_a = (result !== null && result !== void 0 ? result : []).find((s) => s.kind === 'error')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '')
        : (0, value_wrappers_1.makeValue)(result.map((r) => r.value), [...result.reduce((soFar, r) => {
                var _a;
                for (const v of ((_a = r.variables) !== null && _a !== void 0 ? _a : []))
                    soFar.add(v);
                return soFar;
            }, new Set())]);
}
exports.evaluateExpressionList = evaluateExpressionList;
